import React from 'react';
import { Typography } from 'antd';
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <Typography.Title level={5} style={{textAlign: 'center', color: 'white'}}>
                All rights reserved. <br/>
                Cryptonium_Cliff
            </Typography.Title>
        </div>
    )
}

export default Footer
